import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Features', path: '/features' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-[rgba(36,64,97,0.95)] backdrop-blur-md' 
        : 'bg-transparent'
    }`}>
      <div className="absolute inset-0 overflow-hidden">
        <div className="blueprint-grid-overlay"></div>
        {isScrolled && <div className="blueprint-glow-overlay"></div>}
      </div>
      
      <nav className="container mx-auto px-6 py-4 relative">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <div className="header-logo-container">
              <div className="header-gear gear-spin"></div>
              <div className="header-gear gear-spin-reverse"></div>
              <span className="text-2xl font-mono font-bold text-[rgba(100,180,255,0.9)] tracking-wider group-hover:text-[rgba(200,230,255,1)] transition-colors duration-300">
                NTC
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-sm font-mono tracking-wide transition-all duration-200 nav-link ${
                  location.pathname === item.path
                    ? 'text-[rgba(100,180,255,1)] nav-link-active'
                    : 'text-[rgba(100,180,255,0.7)] hover:text-[rgba(100,180,255,1)]'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/demo"
              className="blueprint-button font-mono text-sm tracking-wide"
            >
              Request Demo
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[rgba(100,180,255,0.9)] hover:text-[rgba(100,180,255,1)]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <XMarkIcon className="h-6 w-6" />
            ) : (
              <Bars3Icon className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        <motion.div
          initial={false}
          animate={isMobileMenuOpen ? 'open' : 'closed'}
          variants={{
            open: { opacity: 1, height: 'auto' },
            closed: { opacity: 0, height: 0 }
          }}
          className="md:hidden overflow-hidden"
        >
          <div className="py-4 space-y-4">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`block text-sm font-mono tracking-wide transition-colors duration-200 ${
                  location.pathname === item.path
                    ? 'text-[rgba(100,180,255,1)]'
                    : 'text-[rgba(100,180,255,0.7)] hover:text-[rgba(100,180,255,1)]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/demo"
              className="block blueprint-button-mobile font-mono text-sm tracking-wide text-center"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Request Demo
            </Link>
          </div>
        </motion.div>
      </nav>
    </header>
  );
};

export default Header; 